"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpSearchInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var yup = __importStar(require("yup"));
var DpSearchInput_styled_1 = require("./DpSearchInput.styled");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var threshold = 4;
var limit = 900;
var DpSearchInput = function (props) {
    var _a = (0, react_1.useState)(''), value = _a[0], setValue = _a[1];
    var _b = (0, react_1.useState)(''), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(0), debounceTimeout = _c[0], setDebounceTimeout = _c[1];
    var placeholder = props.placeholder, submissionHandler = props.submissionHandler, suggestionHandler = props.suggestionHandler;
    var validationSchema = yup.string().trim().required().min(threshold);
    var handleSubmission = (0, react_1.useCallback)(function (submitSearch) {
        var throttling = true;
        return function (e) {
            if (throttling && e.key === 'Enter') {
                try {
                    validationSchema.validateSync(value);
                    setError('');
                    submitSearch(value);
                    throttling = !throttling;
                    setTimeout(function () {
                        throttling = !throttling;
                    }, limit);
                }
                catch (err) {
                    var errorObj = err;
                    // TODO: setError(error.message)
                    console.log(errorObj.message);
                }
            }
        };
    }, [validationSchema, setError, value]);
    var handleSuggestion = (0, react_1.useCallback)(function (suggestSearch) { return function (e) {
        var liaison = e.target.value;
        var time = debounceTimeout;
        setValue(liaison);
        clearTimeout(time);
        time = window.setTimeout(function () {
            try {
                validationSchema.validateSync(liaison);
                setError('');
                suggestSearch(liaison);
            }
            catch (err) {
                var errorObj = err;
                // TODO: setError(error.message)
                console.log(errorObj.message);
            }
        }, limit);
        setDebounceTimeout(time);
    }; }, [debounceTimeout, setValue, validationSchema, setError, setDebounceTimeout]);
    return ((0, jsx_runtime_1.jsxs)(DpSearchInput_styled_1.StyledSearchInput, { "data-testid": "search-input", children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.InputGroup, { className: "bg-white", children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.InputGroup.Text, { className: "border-0 text-primary", children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "search" }) }) }), (0, jsx_runtime_1.jsx)("input", { className: "search-input border-0", placeholder: placeholder, "aria-label": placeholder, value: value, onChange: handleSuggestion(suggestionHandler), onKeyPress: handleSubmission(submissionHandler) }), (0, jsx_runtime_1.jsx)("div", { className: "validation-errors", children: error })] }));
};
exports.DpSearchInput = DpSearchInput;
exports.default = exports.DpSearchInput;
